// eslint-disable-next-line import/prefer-default-export
export class BaseDatasetDTO {
    identifier: string | null = null;

    title: string | null = null;

    unit: string | null = null;

    companyId: number | null = null;

    categoryId: number | null = null;
    
    groupId: number | null = null;

    decimalPlaces: number = 1;

    stringValueMapper: number | null = null;
    
    dataType: string | null = null;

    datasetClass: string | null = null;
    
    accessType: string | null = null;
    
    deviceId: number | null = null;
    
    tags: Array<string> = [];

    constructor(data: Partial<BaseDatasetDTO>) {
        if (data) {
            Object.assign(this, data);
        }
    }

    toString(): string {
        return `${this.title} | ${this.unit}`;
    }
}